<script>
/* global $ */

export default {
  name: 'HistoryCompanySlider',
  data() {
    return {

    };
  },
  created() {
    $('.history__scroll .history__items').slick({
      variableWidth: true,
      dots: false,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 4,
      swipeToSlide: true,
      speed: 300,
      outerEdgeLimit: true,
      arrows: true,
      prevArrow: $('.arrow_left'),
      nextArrow: $('.arrow_right'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 555,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};

</script>

<style lang="scss">
  @import './HistoryCompanySlider.scss';
</style>
